// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import getHasSample, { HasSampleModelParameter } from "@store/Framework/Common/Utilities/samples/getHasSample";
import { getIsB2BCustomer } from "@store/Framework/Store/Data/BillTos/BillTosSelectors";

function getCanOrderSample(state: ApplicationState, model: HasSampleModelParameter): boolean;
function getCanOrderSample(isB2BCustomer: boolean, model: HasSampleModelParameter): boolean;
function getCanOrderSample(param: ApplicationState | boolean, model: HasSampleModelParameter): boolean {
    const isB2BCustomer = typeof param === "boolean" ? param : getIsB2BCustomer(param);

    return getHasSample(model) && !isB2BCustomer;
}

export default getCanOrderSample;
